module.exports = new __parcel__URL__("long.9e540775.jpg").toString();